import dayjs from 'dayjs';
import { formatDateMMDDYYYY } from '../../../../utils/formatUtils';

export const createDefaultAuditDateRange = (): [Date, Date] => {
    const end = dayjs();
    const start = end.subtract(6, 'day');
    return [start.toDate(), end.toDate()];
};

export const formatAuditDateForApi = (date: Date) => dayjs(date).format('YYYY-MM-DD');

export const formatAuditDateRangeLabel = (range: [Date | null, Date | null]): string => {
    const [start, end] = range;
    if (!start || !end) return '';
    return `${formatDateMMDDYYYY(start)} - ${formatDateMMDDYYYY(end)}`;
};
